/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { getCurrentMilestone } from '@linc-technologies/linced-common/utils/progressions';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ProgressOverview extends Component {
  @service
  dates;

  @service
  features;

  @service
  store;

  // Props
  // numTermsToShow specifies the number of terms to display in the overview.
  numTermsToShow = 8;

  // person provides the person model to display an assessment overview for.
  person = null;

  // personRecord is used to load promisified person to calculate correct milestones.
  personRecord = null;

  // onEdit provides a callback for when a user clicks on a progression's edit
  // button.
  onEdit() {}

  // State
  @tracked
  loading = true;

  subjectKey = 'goal_subject_id';

  @computed('subjects.@each.milestone_set_id')
  get subjectsByMilestoneSet() {
    if (isEmpty(this.subjects)) {
      // Not loaded yet, or no subjects.
      return {};
    }
    return this.subjects.reduce((mapped, subject) => {
      let setId = subject.milestone_set_id || 'default';
      if (isEmpty(mapped[setId])) {
        mapped[setId] = [];
      }
      mapped[setId].push(subject);
      return mapped;
    }, {});
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);

    this.loading = true;
    Promise.resolve(this.person).then((person) => {
      let promises = {
        milestones: this.store.query('milestones/milestone', {
          progressionType: ProgressionType.PROGRESSION,
        }),
        milestoneSets: this.store.query('milestones/milestone-set', {
          include: 'milestones',
        }),
        levels: this.store
          .findAll('milestones/level')
          .then((levels) =>
            levels.slice().sort((a, b) => a.sequence - b.sequence),
          ),
        expectations: this.store.findAll('milestones/expectation'),
        subjects: this.store
          .query('goals/subject', { trackable: true })
          .then((subjects) =>
            subjects
              .slice()
              .sort((a, b) => (a.label || '').localeCompare(b.label || '')),
          ),
        progressions: this.store.query('milestones/progression', {
          type: ProgressionType.PROGRESSION,
          personId: person.id,
          latest: true,
        }),
      };
      hash(promises).then((data) => {
        data.loading = false;
        data.personRecord = person;
        this.setProperties(data);
      });
    });
  }

  @action
  getMilestonesToShow(subject) {
    let current = getCurrentMilestone(
      subject.milestones,
      this.personRecord,
      this.dates.rolloverMonthDate,
    );

    if (isEmpty(current)) {
      return;
    }

    let currentIndex = subject.milestones.indexOf(current);
    if (currentIndex >= this.numTermsToShow) {
      return subject.milestones
        .slice(currentIndex - (this.numTermsToShow - 1), currentIndex + 1)
        .reverse();
    }
    return subject.milestones.slice(0, currentIndex + 1).reverse();
  }
}
